"use client";

// Delat läge för "är en mobil/läsplatta kopplad just nu?" på datorn.
// MobileQrButton pollar /api/mobile-pair/current (30 s) och QR-modalen vet
// exakt när en koppling tillkommer eller bryts — båda skriver hit, så att
// ScanLosning kan byta knappuppsättning (platta ⇒ "Skicka till läsplattan")
// utan att varje uppgift pollar själv.

import { useSyncExternalStore } from "react";

export type ParkopplingEnhet = "mobil" | "platta";

export interface Parkoppling {
  active: boolean;
  enhet: ParkopplingEnhet | null;
}

const INGEN: Parkoppling = { active: false, enhet: null };

let nuvarande: Parkoppling = INGEN;
const lyssnare = new Set<() => void>();

export function sattParkoppling(p: Parkoppling): void {
  if (p.active === nuvarande.active && p.enhet === nuvarande.enhet) return;
  nuvarande = p.active ? p : INGEN;
  for (const l of lyssnare) l();
}

/** Tolkar svaret från GET /api/mobile-pair/current. */
export function parkopplingUrSvar(data: { active?: boolean; enhet?: unknown } | null): Parkoppling {
  if (!data?.active) return INGEN;
  const enhet = data.enhet === "platta" || data.enhet === "mobil" ? data.enhet : null;
  return { active: true, enhet };
}

/** Hämta läget direkt (t.ex. när QR-modalen just sett "active"). */
export async function uppdateraParkoppling(): Promise<void> {
  try {
    const res = await fetch("/api/mobile-pair/current", { cache: "no-store" });
    if (!res.ok) return;
    sattParkoppling(parkopplingUrSvar((await res.json()) as { active?: boolean; enhet?: unknown }));
  } catch {
    // tyst — nästa poll rättar till
  }
}

function prenumerera(cb: () => void) {
  lyssnare.add(cb);
  return () => {
    lyssnare.delete(cb);
  };
}

export function useParkoppling(): Parkoppling {
  return useSyncExternalStore(prenumerera, () => nuvarande, () => INGEN);
}
